// Shared revenue/cost/profit math for anything working with order line
// items — used by the mock order seed data, the orders store, and the
// admin dashboard's profit numbers, so there's exactly one definition
// of "how profit is computed" in the app.

export function orderRevenue(items) {
  return items.reduce((sum, i) => sum + i.price * i.quantity, 0);
}

export function orderCost(items) {
  return items.reduce((sum, i) => sum + (i.costPrice || 0) * i.quantity, 0);
}

export function orderProfit(items) {
  return orderRevenue(items) - orderCost(items);
}

export function orderItemCount(items) {
  return items.reduce((sum, i) => sum + i.quantity, 0);
}

// Discount is informational for the customer-facing total only — the
// actual sold price per line is whatever the admin confirms when the
// order is edited or marked fulfilled (see components/admin/
// OrderFormModal.jsx), so this never touches costPrice/profit math above.
export function couponDiscount(coupon, subtotal) {
  if (!coupon) return 0;
  const raw = coupon.type === "percent" ? subtotal * (coupon.value / 100) : coupon.value;
  return Math.min(Math.max(raw, 0), subtotal);
}
